import { useBlocNext } from "@blac/react";
import type { FC } from "react";
import MealInsightsCubit from "src/state/MealInsightsCubit/MealInsightsCubit";
import { DebugToggleSwitch } from "./debug.styles";

const DebugMeals: FC = () => {
  const [{ simulateFirstTimeExperience }, { setSimulateFirstTimeExperience }] =
    useBlocNext(MealInsightsCubit);

  return (
    <DebugToggleSwitch>
      <span className="label">
        Show First Time Experience when no logged meals
      </span>
      <input
        type="checkbox"
        checked={simulateFirstTimeExperience}
        onChange={(e) => setSimulateFirstTimeExperience(e.target.checked)}
      />
      <span className="switch" />
    </DebugToggleSwitch>
  );
};

export default DebugMeals;
